import React, { useTransition } from 'react';
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { Link, useNavigate } from 'react-router-dom';
import fetchUserallowedRoutes2 from '../../hooks/fetchUserallowedRoutes2';
import { getStorageItem } from '../../utils/localStorage';
import { useTranslation } from 'react-i18next';

const SideBar4 = () => {
  const { t } = useTranslation(['common']);
  const navigate = useNavigate();
  let user;
  getStorageItem(`user`, (result) => {
    user = JSON.parse(result);
  });
  function removeDuplicates(originalArray) {
    let uniqueArray = [];
    let uniqueObject = {};
  
    for (let i = 0; i < originalArray.length; i++) {
      const obj = originalArray[i];
      const key = JSON.stringify(obj);
  
      if (!uniqueObject[key]) {
        uniqueArray.push(obj);
        uniqueObject[key] = true;
      }
    }
  
    return uniqueArray;
  }
  function mergeObjectsByKey(arr, key) {
    const groupedObjects = {};
  
    arr.forEach(obj => {
      const keyValue = obj[key];
      if (!groupedObjects[keyValue]) {
        groupedObjects[keyValue] = {};
      }
      for (let [k, v] of Object.entries(obj)) {
        if (k !== key) {
          groupedObjects[keyValue][k] = (groupedObjects[keyValue][k] || []).concat(v);
        } else {
          groupedObjects[keyValue][k] = v;
        }
      }
    });
  
    return Object.values(groupedObjects);
  }
  
  const routes2 = fetchUserallowedRoutes2(user.roleId).response;
  console.log(routes2);
  const unqArr=routes2?removeDuplicates(routes2):[];
  console.log(unqArr);
  const mergedArr = routes2?mergeObjectsByKey(routes2, 'module'):[];
console.log(mergedArr);
  function extractValue(arr, module) {
    let extractedValue = arr.map((item) => {
      console.log(item);
      return item[module];
    });

    return extractedValue;
  } 
  
  let modules = [];
  if (routes2)
    routes2.forEach((ele) => {
      modules.push(ele.module);
    });
    let newArr=[]
    if (routes2)
    routes2.forEach((ele) => {
    newArr.push({module:ele.module,render:ele.is_render,action:ele.action,root:ele.is_root});
    });
console.log(newArr);


    let newArray=[]

if(routes2){
  for(let i=0;i<routes2.length;i++){
  modules.forEach((ele) => {
if(ele===routes2[i].module&&routes2.is_render){
  newArray.push(routes2[i])
}
})
}
}

console.log(newArray)

// let array1 = [  { name: 'John', age: 30 },  { name: 'Jane', age: 25 },  { name: 'Jim', age: 35 }];

// let array2 = [  { name: 'John', age: 30 },  { name: 'Jane', age: 27 },  { name: 'Jim', age: 35 }];

let matchedArray = [];

// for (let i = 0; i < array1.length; i++) {
//   let matchFound = array2.some(function(array2Object) {
//     return array1[i].name === array2Object.name && array1[i].age === array2Object.age;
//   });

//   if (matchFound) {
//     matchedArray.push(array1[i]);
//   }
// }

// console.log(matchedArray);
// if(routes2){
//   for (let i = 0; i < module.length; i++) {
//     let matchFound = routes2.some(function(array2Object) {
//       console.log(array2Object)
//       return module[i] === array2Object.module
//     });
  
//     if (matchFound) {
//       matchedArray.push(routes2[i]);
//     }
//   }




// }

// console.log(matchedArray)

  modules = [...new Set(modules)];
  console.log(modules);
  const onRouteHandler=(element)=>{
    window.alert("Hello "+element);

  }
  const logOutHandler = () => {
    console.log("Log Out");
    localStorage.removeItem('user');
    navigate('/');
    window.location.reload();
  };
  return (
    <div class=' col-lg-2 pl-0' style={{ display: 'flex', width: '20%', height:"100vh"}} id='sidebar' role='navigation'>
      <Sidebar >

        <Menu>

          {modules.map((element) => { 
            console.log(element)
            // if(element.root)return  <>  <hr className='fade-effect1'/><MenuItem> 
            //  <Link to={`/${element.module}${element.action}`} style={{textTransform:"capitalize"}}>{(element.module)}</Link>
            //  </MenuItem></>
            //  else 
             return (
              <>
             <hr/>
              {/* <hr className='fade-effect1'/> */}
               {
               element!='orguser'&&element!="userperm"?
               
               <SubMenu style={{textTransform:"capitalize"}}  label={((element==="transaction"?"donation":element==="events"?"Courses & Events":element==="orgreport"?"reports":element ))}>
                  {routes2.map((ele) => {
                    // console.log(ele)
                    // console.log(element)
                    if ((ele.module === element)&&ele.is_render) {
                      return (
                          <MenuItem key={ele.role_id}>
                            <Link to={`/${ele.module}${ele.action}`} style={{textTransform:"capitalize"}}>{(ele.action).slice(1)}</Link>
                          </MenuItem>
                      );
                    }
                  })}
                </SubMenu>
          :" "}
              </>
            );
          })}
          <div class="row">
            <div class="col-lg-11 text-center">
            <button class=" btn button mt-5 text-white" onClick={logOutHandler}>Sign out</button>
            </div>
          </div>
          {/* <SubMenu class="mt-5" Label={"User"}>
            <MenuItem>
            Sign Out
            </MenuItem>
          </SubMenu> */}
        </Menu>
      </Sidebar>
    </div>
  );
};

export default SideBar4;
